import { render, staticRenderFns } from "./RecentMovements.vue?vue&type=template&id=3dee7c46"
import script from "./RecentMovements.vue?vue&type=script&lang=js"
export * from "./RecentMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports